import img1 from '../assets/images/slider1.png'

export const bannerData = [
    {
        id:1,
        image:img1,
        heading:'Final Offer',
        button: 'Shop Now'
    },
    {
        id:2,
        image:img1,
        heading:'Final Offer',
        button: 'Shop Now'
    },
    {
        id:3,
        image:img1,
        heading:'Final Offer',
        button: 'Shop Now'
    },
]